const VITE_API_URL = import.meta.env.VITE_API_URL as string | undefined;

export const API_BASE_URL = (VITE_API_URL ?? 'https://chikara-bff.qa-albo.tech').replace(/\/$/, '');

export const API_ENDPOINTS = {
    // Auth
    auth: {
        login: '/api/v1/commands/login',
        logout: '/api/v1/commands/logout',
        register: '/api/v1/commands/register',
        refreshToken: '/api/v1/commands/refresh',
        forgotPassword: '/api/v1/commands/user-password-reset',
        resetPassword: '/api/v1/commands/user-password-confirm',
        preLogin: '/api/v1/commands/pre-login',
    },
    mfa: {
        mfaSetup: '/api/v1/commands/mfa-setup',
        /** Registra challenge 2FA para un comando (p. ej. `login`) y devuelve `mfa_token` */
        mfaSend: '/api/v1/commands/mfa-send',
        /** OTP tras escanear QR / onboarding (lleva `mfa_token` del setup) */
        mfaValidate: '/api/v1/commands/mfa-validate',
        /** OTP en login con MFA: body incluye `mfa_token` del `mfa-send` y metadatos del comando */
        mfaVerify: '/api/v1/commands/mfa-verify',
    },
    batch: {
        get: '/api/v1/commands/card-batch-get',
        list: '/api/v1/commands/card-batch-list',
        confirm: (suitcase_uuid: string) => `/api/v1/commands/card-batch-confirm/${suitcase_uuid}/confirm`,
        create: '/api/v1/commands/card-batch-create',
    },
    card: {
        cancel: '/api/v1/commands/card-cancel',
        replace: '/api/v1/commands/card-replace',
        block: '/api/v1/commands/account-card-block',
        unblock: '/api/v1/commands/account-card-unblock',
        pinGet: '/api/v1/commands/account-card-pin-get',
        pinChange: '/api/v1/commands/account-card-pin-change',
        activate: '/api/v1/commands/card-activate',
        list: '/api/v1/commands/card-list'
    },
    account: {
        get: (uuid: string) => `/api/v1/commands/account-get/account/${uuid}/get`,
        list: '/api/v1/commands/account-list',
        create: '/api/v1/commands/account-create',
        approve: '/api/v1/commands/account-approve',
        limitUpdate: '/api/v1/commands/account-limit-update',
        listTx: '/api/v1/commands/account-list-tx'
    },
    metadata: {
        update: (uuid: string) => `/api/v1/commands/card-metadata-update/card/${uuid}/metadata`,
    },
    tags: {
        create: (customerUuid: string, accountUuid: string) => `/api/v1/commands/customer-tag-manager/customer/${customerUuid}/account/${accountUuid}/tags`,
        update: (customerUuid: string, accountUuid: string, tag_name: string) => `/api/v1/commands/tags-update/customer/${customerUuid}/account/${accountUuid}/tags/${tag_name}`,
        delete: (customerUuid: string, accountUuid: string, tag_name: string) => `/api/v1/commands/tags-delete/customer/${customerUuid}/account/${accountUuid}/tags/${tag_name}`,
    },
    // Users
    users: {
        profile: '/users/profile',
        updateProfile: '/users/profile',
    },
    // Accounts
    accounts: {
        list: '/accounts',
        detail: (id: string) => `/accounts/${id}`,
        balance: (id: string) => `/accounts/${id}/balance`,
    },
    // Transfers
    transfers: {
        create: '/transfers',
        validate: '/transfers/validate',
    },
    team: {
        getMember: '/api/v1/commands/user-get',
        createMember: '/api/v1/commands/user-create',
        inviteAccept: '/api/v1/commands/user-invitation-accept',
        approveMember: '/api/v1/commands/user-approve',
        updateMember: '/api/v1/commands/user-update',
        cancelMember: '/api/v1/commands/user-delete',
        listMembers: '/api/v1/commands/user-list',
    },
    onboarding: {
        acceptInvite: '/api/v1/commands/user-invitation-accept',
        setupPassword: '/api/v1/commands/user-password-confirm',
        activateCard: '/api/v1/commands/account-create',
    },
    credit: {
        get: (customer_uuid: string) => `/api/v1/commands/account-credit-summary-get/${customer_uuid}`,
        statementList: '/api/v1/commands/account-statement-list',
    },
    customer: {
        summary: '/api/v1/commands/customer-credit-summary',
    }
} as const;
